import theme from './theme.grey';
export default {
  "uniqueId": "discuss02",
  "appName": "forum",
  "inboxType": "forum",
  "label": "Forum",
  "labelColor": theme.primaryColor,
  "createdAt": "2019-06-02T06:48:00",
  "updatedAt": "2019-06-11T06:48:00",
  "messages": [{
    "uniqueId": 1,
    "status": "publish",
    "date": "2018-10-03T06:48:00",
    "author": {
      "name": "Arne Andersen",
      "email": "ivar.es@online.no"
    },
    "subject": "Hvor mange fugler går det på et snes?",
    "message": "Her er det en underlig prioritering av innholdet i bildet. Fatet er knapt synlig der det står på en hylle. Hovedmotivet er en sponhøvel, sponokse. En slik ble brukt til å høvle takspon, og ble kjørt over en stokk omtrent som en plog."
  }, {
    "uniqueId": 3,
    "status": "unread",
    "date": "2018-05-02T06:48:00",
    "author": {
      "name": "Ivar Stav",
      "email": "ivar.es@online.no"
    },
    "message": "Bilene fra venstre: Ford Taunus 17M 1958-60, SAAB, Moskwich 1954-55, Ford Zephyr Six 1951-53."
  }]
};